import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArrowDownIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M4.94 5.727 8 8.78l3.06-3.053.94.94-4 4-4-4 .94-.94Z" />
  </Icon>
);

export default memo(ArrowDownIcon);
